import { Form } from "react-router-dom"
import { user } from "../../backoffice/dtos/authentication/user"
import { Promotion } from "../../backoffice/dtos/promotions/promotion"
import { Col, Container, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useMemo } from "react"
import { PromotionInfo } from "../../backoffice/dtos/promotions/PromotionInfo"
import { useTranslation } from "react-i18next"

export default function PromotionInfoComponent(
    {
        headerKey,
        user,
        promotion,
        promotionInfo,
        toggle,
    }: {
        headerKey: string
        user: user | undefined
        promotion: Promotion
        promotionInfo: PromotionInfo;
        toggle: () => void
    }
) {
    const {t} = useTranslation(['promotion_timeline','common','promotion'])

    const color = useMemo(() => {
        return ["#00AA00", "#55FF55", "#FF3333"][promotionInfo.state];
    }, [promotionInfo.state]);

    const text = useMemo(() => {
        return ["Created", "Updated", "Deleted"][promotionInfo.state];
    }, [promotionInfo.state]);
    return (
        <Container>
            {
                promotionInfo.error && (
                    <Row className="gy-2 p-2">
                        <Col lg={12}>
                            <InputGroup>
                                <InputGroupText style={{ backgroundColor: color, color: "white" }} >
                                    {t("Upload Error")}
                                </InputGroupText>
                                <Input type="text" name='state' value={promotionInfo.error} disabled={true} />
                            </InputGroup>
                        </Col>
                    </Row>
                )
            }
            <Row className="gy-2 p-2">
                <Label for="creationDate" lg={2}>{t('Date')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Creation')} 
                        </InputGroupText>
                        <Input type="text" name='creationDate' value={promotionInfo.creationDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('Update')}
                        </InputGroupText>
                        <Input type="text" name='updateDate' value={promotionInfo.updateDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="uploadDate" lg={2}>{t('Upload')}</Label>

                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText>
                            {t('To Upload')}
                        </InputGroupText>
                        <Input type="text" name='dateAllowedToUpload' value={promotionInfo.dateAllowedToUpload} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
                <Col lg={5}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: promotionInfo.hasBeenUploaded ? "green" : "red", color: "white" }} >
                            {t('Upload')}
                        </InputGroupText>
                        <Input type="text" name='uploadDate' value={promotionInfo.uploadDate} disabled={true} className="text-align-end"/>
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Col lg={2}/>
                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText>{t('Retries')}</InputGroupText>
                        <Input type="text" name='uploadRetries' value={promotionInfo.uploadRetries} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
            <Row className="gy-2 p-2">
                <Label for="state" lg={2}>{t('PO State')}</Label>

                <Col lg={4}>
                    <InputGroup>
                        <InputGroupText style={{ backgroundColor: color, color: "white", width: 40 }} />
                        <Input type="text" name='state' value={text} disabled={true} />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
    );
}